import React from 'react';
import numberHelper from '../../util/numberFormatter'
import dateHelper from '../../util/dateFormatter'
import { Link } from 'react-router-dom'

const TransactionList = props => {
  if (!props.data) {
    return (
      <div className={'LoadingPane'}>Loading...</div>
    );
  }

  if ((props.data.recentTransactions && props.data.recentTransactions.length) === 0 || !props.data.recentTransactions) {
    return (
      <div>
        No transactions found.
      </div>
    )
  }

  let itemCount = 0

  return (
    <ul className={`DataList TransactionList`}>
      {
        props.data.recentTransactions.map(item => {
          let transactionKey = item.txn || item.key
          let createdDate = item.created || new Date()
          itemCount++
          return (
            <li key={item.key} className={itemCount === 1 && props.data.newTransactionAdded ? 'new-transaction' : ''}>
              <strong><Link to={`/transaction/${transactionKey}`}>{transactionKey}</Link></strong>
              <span className={'shared'}>{numberHelper.Formatter.toDecimalTrim(item.amount)}</span>
              <em className={'shared'}>{dateHelper.Formatter.toLocalString(createdDate)}</em>
            </li>
          )
        })
      }
    </ul>
  )
}

export default TransactionList
